import React from 'react';

function DetailField({ label, name, value, onClick, style }) {
  return (
    <div>
      <div className="Label_name_details">
        <label>{label}</label>
        <input
          type="text"
          name={name}
          className="input_field_pgmdetails"
          value={value || ""}
          readOnly
          onClick={onClick}
          style={style}
        />
      </div>
    </div>
  );
}

export default DetailField;
